const LangThailandFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
    <rect width="16" height="11" fill="#F4F5F8" />
    <rect width="16" height="1.83" fill="#A51931" />
    <rect width="16" height="3.67" y="3.67" fill="#2D2A4A" />
    <rect width="16" height="1.83" y="9.17" fill="#A51931" />
  </svg>
);

export default LangThailandFlag;
